var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.user_edit") } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner
                ? _c("spinner")
                : _c(
                    "form-accordion",
                    {
                      attrs: {
                        isTitleUpperCase: false,
                        title: _vm.$t("administration.user_info"),
                      },
                    },
                    [
                      _c("div", { staticClass: "form-group" }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t(
                                    "administration.identifier"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "administration.identifier"
                                  ),
                                },
                                model: {
                                  value: _vm.login,
                                  callback: function ($$v) {
                                    _vm.login = $$v
                                  },
                                  expression: "login",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t(
                                    "administration.user_name"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "administration.user_name"
                                  ),
                                },
                                model: {
                                  value: _vm.name,
                                  callback: function ($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("label", { attrs: { for: "sel4" } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("administration.active")) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.active,
                                      expression: "active",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "sel4",
                                    readonly: "",
                                    "aria-label": _vm.$t(
                                      "administration.active"
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.active = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("administration.no")) +
                                        " "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("administration.yes")) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "12" } },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { checked: false },
                                  model: {
                                    value: _vm.changePassword,
                                    callback: function ($$v) {
                                      _vm.changePassword = $$v
                                    },
                                    expression: "changePassword",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("administration.reset_password")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.changePassword
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("common.pwd"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "d-flex" }, [
                                    _vm.passwordType === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password",
                                            },
                                          ],
                                          staticClass:
                                            "form-control inputAccordionForm h-30px",
                                          attrs: {
                                            placeholder: _vm.$t("common.pwd"),
                                            autocomplete: "new-password",
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(_vm.password)
                                              ? _vm._i(_vm.password, null) > -1
                                              : _vm.password,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.password,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.password = $$a.concat([
                                                      $$v,
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.password = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.password = $$c
                                              }
                                            },
                                          },
                                        })
                                      : _vm.passwordType === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password",
                                            },
                                          ],
                                          staticClass:
                                            "form-control inputAccordionForm h-30px",
                                          attrs: {
                                            placeholder: _vm.$t("common.pwd"),
                                            autocomplete: "new-password",
                                            type: "radio",
                                          },
                                          domProps: {
                                            checked: _vm._q(_vm.password, null),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.password = null
                                            },
                                          },
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password",
                                            },
                                          ],
                                          staticClass:
                                            "form-control inputAccordionForm h-30px",
                                          attrs: {
                                            placeholder: _vm.$t("common.pwd"),
                                            autocomplete: "new-password",
                                            type: _vm.passwordType,
                                          },
                                          domProps: { value: _vm.password },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.password = $event.target.value
                                            },
                                          },
                                        }),
                                    _vm._v(" "),
                                    _c("button", {
                                      staticClass:
                                        "icon icon-password mt-2 pt-1 icon-field",
                                      class: [
                                        _vm.isPasswordFieldHidden
                                          ? "fa-duotone fa-eye"
                                          : "fa-duotone fa-eye-slash",
                                      ],
                                      attrs: {
                                        type: "button",
                                        "aria-label": _vm.isPasswordFieldHidden
                                          ? _vm.$t("common.show_password")
                                          : _vm.$t("common.hide_password"),
                                        "aria-pressed":
                                          !_vm.isPasswordFieldHidden,
                                      },
                                      on: { click: _vm.switchPasswordType },
                                    }),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("common.security.verif_password")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "d-flex" }, [
                                    _vm.passwordVerifType === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.passwordVerif,
                                              expression: "passwordVerif",
                                            },
                                          ],
                                          staticClass:
                                            "form-control inputAccordionForm h-30px",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "common.security.verif_password"
                                            ),
                                            autocomplete: "new-password",
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.passwordVerif
                                            )
                                              ? _vm._i(
                                                  _vm.passwordVerif,
                                                  null
                                                ) > -1
                                              : _vm.passwordVerif,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.passwordVerif,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.passwordVerif =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.passwordVerif = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.passwordVerif = $$c
                                              }
                                            },
                                          },
                                        })
                                      : _vm.passwordVerifType === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.passwordVerif,
                                              expression: "passwordVerif",
                                            },
                                          ],
                                          staticClass:
                                            "form-control inputAccordionForm h-30px",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "common.security.verif_password"
                                            ),
                                            autocomplete: "new-password",
                                            type: "radio",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.passwordVerif,
                                              null
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.passwordVerif = null
                                            },
                                          },
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.passwordVerif,
                                              expression: "passwordVerif",
                                            },
                                          ],
                                          staticClass:
                                            "form-control inputAccordionForm h-30px",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "common.security.verif_password"
                                            ),
                                            autocomplete: "new-password",
                                            type: _vm.passwordVerifType,
                                          },
                                          domProps: {
                                            value: _vm.passwordVerif,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.passwordVerif =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                    _vm._v(" "),
                                    _c("button", {
                                      staticClass:
                                        "icon icon-password mt-2 pt-1 icon-field",
                                      class: [
                                        _vm.isPasswordVerifFieldHidden
                                          ? "fa-duotone fa-eye"
                                          : "fa-duotone fa-eye-slash",
                                      ],
                                      attrs: {
                                        type: "button",
                                        "aria-label":
                                          _vm.isPasswordVerifFieldHidden
                                            ? _vm.$t("common.show_password")
                                            : _vm.$t("common.hide_password"),
                                        "aria-pressed":
                                          !_vm.isPasswordVerifFieldHidden,
                                      },
                                      on: {
                                        click: _vm.switchPasswordVerifType,
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { cols: "6", sm: "6" },
                            },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    value: "1",
                                    "unchecked-value": "0",
                                    disabled: _vm.receivedFirstLogin,
                                  },
                                  model: {
                                    value: _vm.firstLogin,
                                    callback: function ($$v) {
                                      _vm.firstLogin = $$v
                                    },
                                    expression: "firstLogin",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.receivedFirstLogin
                                          ? _vm.$t(
                                              "administration.reset_password_option"
                                            ) +
                                              " " +
                                              _vm.$t("common.active_par")
                                          : _vm.$t(
                                              "administration.reset_password_option"
                                            )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("administration.user_auth"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "justify-content-start" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "px-0",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "user-profile-select" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("administration.profile")
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.idProfile,
                                              expression: "idProfile",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "user-profile-select",
                                            "aria-label": _vm.$t(
                                              "administration.profile"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.idProfile = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "",
                                                disabled: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "administration.select_profile"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.AllProfiles,
                                            function (profile, index) {
                                              return _c(
                                                "option",
                                                {
                                                  key:
                                                    "filtered-profile-" +
                                                    profile.id +
                                                    "-" +
                                                    index,
                                                  attrs: {
                                                    disabled: profile.disabled,
                                                  },
                                                  domProps: {
                                                    value: profile.id,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(profile.name) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-row", { staticClass: "justify-content-start" }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.sve"),
              icon: "fa-light fa-save",
              variant: "primary",
            },
            on: { click: _vm.changeUser },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }